<div [hidden]="status" class="bg-success sefaz_stripe text-center align-content-center text-white fs-4">Ambiente Homologação Sefaz</div>
